import { Stack, xcss } from '@atlaskit/primitives';
import { defaultStoreUtils } from '@databases/redux';
import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { selectDatabaseDraftByContentId } from '@databases/redux/changesets/selectors';
import { DatabaseChangeType } from '@databases/types/redux';
import { getDatabaseFieldRequired } from '@databases/utils/database/utils';
import React, { type FunctionComponent, useCallback } from 'react';

import FieldSettingsOptionsByType from './FieldSettingsOptionsByType';
import AllowMultiToggle from './shared/AllowMultiToggle';
import { getAllowMultiToggleMessages } from './shared/getAllowMultiToggleMessages';

const containerStyles = xcss({
  paddingInline: 'space.200'
});

type FieldSettingsMenuContentProps = {
  contentId: string;
  fieldId: string;
};

const FieldSettingsMenuContent: FunctionComponent<FieldSettingsMenuContentProps> = ({
  contentId,
  fieldId
}) => {
  const field = defaultStoreUtils.useSelector((state) => {
    const databaseDraft = selectDatabaseDraftByContentId(state, {
      contentId,
      includeDeleted: true
    });

    return getDatabaseFieldRequired(databaseDraft, fieldId);
  });
  const dispatch = defaultStoreUtils.useDispatch();
  const handleOnChangeAllowMulti = useCallback(
    (isMulti: boolean) => {
      dispatch(
        addChangeToDraft(contentId, {
          type: DatabaseChangeType.SET_IS_MULTI,
          fieldId,
          isMulti
        })
      );
    },
    [contentId, dispatch, fieldId]
  );

  const allowMultiMessages = getAllowMultiToggleMessages(field.type);

  // TODO: Include default value wrapper here
  return (
    <Stack space="space.150" xcss={containerStyles}>
      {allowMultiMessages && (
        <AllowMultiToggle
          labelMessage={allowMultiMessages.labelMessage}
          onChange={handleOnChangeAllowMulti}
          tooltipMessage={allowMultiMessages.tooltipMessage}
          value={Boolean(field.settings.multi)}
        />
      )}
      <FieldSettingsOptionsByType fieldType={field.type} />
    </Stack>
  );
};

export default FieldSettingsMenuContent;
